import React from 'react'
import { useCookieConsent } from '../../contexts/CookieConsentContext'
import * as S from './style'

export function CookieBanner (): React.ReactElement | null {
  const { showBanner, acceptCookies, declineCookies } = useCookieConsent()

  if (!showBanner) {
    return null
  }

  return (
    <>
      <S.Backdrop />
      <S.CookieBannerContainer>
        <div className="banner-content">
          <div className="banner-text">
            <h3>Cookies e Privacidade</h3>
            <p>
              Utilizamos cookies para melhorar sua experiência, analisar o tráfego do site e personalizar conteúdo.
              Ao clicar em "Aceitar", você concorda com o uso de cookies analíticos.
              Você pode recusar o uso de cookies, mas isso pode afetar a funcionalidade do site.
            </p>
          </div>
          <div className="banner-actions">
            <S.AcceptButton onClick={acceptCookies}>
              Aceitar Cookies
            </S.AcceptButton>
            <S.DeclineButton onClick={declineCookies}>
              Recusar
            </S.DeclineButton>
          </div>
        </div>
      </S.CookieBannerContainer>
    </>
  )
}
